import { AvailableModules, Features } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import aiImage from 'modules/reports/lib/assets/upsell_ai.png'
import builderImage from 'modules/reports/lib/assets/upsell_builder.png'
import sqlImage from 'modules/reports/lib/assets/upsell_sql.png'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { RequestUpgradeProps } from 'modules/upsell/lib/requestUpgradeTypes'

export const advancedReportsContent = () => [
  {
    src: builderImage,
    title: i18n.t('custom_reports.dashboards.upsell_modal.builder.title'),
    description: i18n.t('custom_reports.dashboards.upsell_modal.builder.description'),
  },
  {
    src: sqlImage,
    title: i18n.t('custom_reports.dashboards.upsell_modal.sql_editor.title'),
    description: i18n.t('custom_reports.dashboards.upsell_modal.sql_editor.description'),
  },
  {
    src: aiImage,
    title: i18n.t('custom_reports.dashboards.upsell_modal.ai.title'),
    description: i18n.t('custom_reports.dashboards.upsell_modal.ai.description'),
  },
]

export const featureToRequest = (): RequestUpgradeProps => ({
  moduleRequested: AvailableModules.analytics,
  featureRequested: Features.analytics_advanced_reports,
  requestSource: 'Upsell modal with feature info',
  requestReason: ValidReasons.MissingFeature,
})
